import axios from "axios";
import {
    tkn,
    requestFactura,
    responseCartSeveralInvoices,
} from "../Types";
import config, { isTurnstileEnabled } from "./../../../config/config";
import { InvoicesCanCuscribe, recoletNewVals } from "../../detail/Helper/Helper";
import { setNewTagCI360, formatConsultFormData } from "../../../utils/tagManager/ci360";
import { checOnlineStatus } from '../Helpers'
import { decryptData } from "../../Utils/Utils";


declare const window: any
//////////////////////////////////
// GET FACTURAS ::::::::::::::::::
export const RequestInvoiceMovistar = async (data: requestFactura, turnstileToken?: string) => {
    let obj: {
        result: boolean,
        [key: string]: any,
        getLastPay?: boolean
    } = { result: false };

    try {
        const isOnline = await checOnlineStatus();
        if (!isOnline) {
            return {
                result: false,
                message: config.alertas.conexion
            }
        }
        /*
        const tokenCaptcha = await window.grecaptcha.execute(config.CaptchaKey, {
            action: 'RequestInvoiceMovistar',
        });
        */
        //Tipo de consulta sus o online

        const dataShoppingCartId = data.shoppingCartId
        let modeConsult = sessionStorage.getItem('modeConsult');
        await axios({
            method: 'post',
            url: config.EPAYCO_REST_RECAUDO_API_INVOICE,
            data: {
                "consulta": [
                    {
                        "parametro": "paymentRef",
                        "value": data.paymentRef
                    },
                    {
                        "parametro": "invoiceType",
                        "value": data.invoiceType
                    },
                    {
                        "parametro": "isRefNumber",
                        "value": data.isRefNumber
                    },
                    {
                        "parametro": "comerce",
                        "value": data.comerce
                    },
                    {
                        "parametro": "referen",
                        "value": data.referen ? data.referen : ""
                    },
                    {
                        "parametro": "novum",
                        "value": data.novum ? data.novum : ""
                    },
                ],
                "tipoConsulta": data.typeConsult ? data.typeConsult : modeConsult,
                "dominio": config.REACT_APP_MOVISTAR_DOMINIO_RECAUDO,
                ...(dataShoppingCartId && { "shoppingCartId": dataShoppingCartId })
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${data.token}`,
                "X-api-key": '',
                ...(isTurnstileEnabled && {
                    "X-Api-Validation": turnstileToken ?? ""
                }),
            }
        })
            .then(async (resp: any) => {
                let decrypData = decryptData(resp.data.data);

                if (resp.data.shoppingCartItems && Array.isArray(resp.data.shoppingCartItems) && resp.data.shoppingCartItems.length > 0) {

                    let allShoppingCartItems = [...resp.data.shoppingCartItems];

                    if (decrypData.facturas && decrypData.facturas.length > 0) {
                        const existingExtra12 = new Set<string>();

                        allShoppingCartItems.forEach((item: any) => {
                            if (Array.isArray(item) && item.length > 0) {
                                const consulta = item[0];
                                if (consulta.success && consulta.data?.facturas) {
                                    consulta.data.facturas.forEach((factura: any) => {
                                        if (factura.extra12) {
                                            existingExtra12.add(factura.extra12);
                                        }
                                    });
                                }
                            }
                        });

                        const facturasNoDuplicadas = decrypData.facturas.filter((factura: any) =>
                            !existingExtra12.has(factura.extra12)
                        );

                        if (facturasNoDuplicadas.length > 0) {
                            allShoppingCartItems.push([{
                                success: true,
                                data: {
                                    facturas: facturasNoDuplicadas,
                                    ultraFacturas: decrypData.ultraFacturas
                                }
                            }]);
                        }
                    }


                    obj.result = true;
                    obj.shoppingCartItems = allShoppingCartItems;
                    return obj;
                }

                if (resp.status === 200) {
                    let { ultraFacturas } = decrypData;
                    let { success, text_response } = await resp.data;
                    let factura = ultraFacturas?.facturas[0] || [];
                    if (!success) {
                        obj.result = false
                        obj.message = text_response
                        obj.getLastPay = false
                    } else if ((ultraFacturas && factura && factura.total) ||
                        (!factura.total && factura.extra11)) {
                        obj = decrypData;
                        obj.result = true
                        obj.message = 'Facturas consultadas con éxito';
                        obj.getLastPay = false;
                    } else {
                        if (factura.total == 0) {
                            obj = decrypData;
                            obj.result = true;
                            obj.message = 'Factura sin Saldo Pendiente';
                            obj.getLastPay = true;
                        } else {
                            obj.result = false
                            obj.message = 'Consultó y no encontró facturas.';
                            obj.getLastPay = false
                        }
                    }
                } else {
                    obj.result = false
                    obj.message = 'Error consultando facturas'
                    obj.getLastPay = false
                }
            })
            .catch((e: any) => {
                obj.result = false
                obj.message = config.alertas.facturas
            })
    } catch (e) {
        obj.result = false
        obj.message = config.alertas.facturas
        console.log({ e })
    }
    return obj;
}


//////////////////////////////////
// VALIDATE CART RESPONSE ::::::::
function ValidateCart(data: responseCartSeveralInvoices) {
    let obj: {
        [key: string]: any;
    } = {
        hasCart: false,
        result: false,
    }
    if (data.ultraFacturas && data.ultraFacturas.facturas?.length > 1) {
        sessionStorage.setItem('shoppingCartId', String(data.ultraFacturas.id))
        sessionStorage.setItem('shoppingCartTipo', data.ultraFacturas?.tipo || "")
        obj.facturas = data.ultraFacturas;
        obj.hasCart = true;
    }
    return obj;
}


//////////////////////////////////
// GET CART invoices :::::::::::::
export const RequestCart = async (token: string, PaymentRef: any, tipoarchivo: string, filial: number, turnstileToken?: string) => {
    let obj: {
        result: boolean,
        [key: string]: any
    } = { result: false };

    let urlProyectos: any = {
        1: config.REACT_APP_MOVISTAR_DOMINIO_RECAUDO,
        2: config.REACT_APP_TELEBUCARAMANGA_DOMINIO,
        3: config.REACT_APP_METROTEL_DOMINIO,
    }

    let publicKey: any = {
        1: config.REACT_APP_MOVISTAR_RECAUDO_PUBLIC_KEY,
        2: config.REACT_APP_TELEBUCARAMANGA_RECAUDO_PUBLIC_KEY,
        3: config.REACT_APP_METROTEL_RECAUDO_PUBLIC_KEY,
    }

    try {
        /*
        const tokenCaptcha = await window.grecaptcha.execute(config.CaptchaKey, {
            action: 'RequestCart',
        });
        */
        await axios({
            method: 'POST',
            url: config.EPAYCO_REST_RECAUDO_API_CONSULT_CART,
            data: {
                "consulta": [
                    {
                        "parametro": "paymentRef",
                        "value": PaymentRef
                    },
                    {
                        "parametro": "tipoProyecto",
                        "value": tipoarchivo
                    },
                    {
                        "parametro": "dominio",
                        "value": urlProyectos[filial]
                    }
                ],
                "public_key": publicKey[filial]
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "X-api-key": '',
                ...(turnstileToken && { "X-Api-Validation": turnstileToken })
            }
        })
            .then(async (resp: any) => {
                let decrypData = decryptData(resp.data.data);
                if (resp.status === 200) {
                    let resData = ValidateCart(decrypData);
                    obj.result = resData.hasCart;
                    obj.facturas = resData.facturas;
                    obj.ultraFacturas = decrypData.ultraFactura
                } else {
                    obj.result = false
                    obj.ultraFactura = decrypData.ultraFacturas
                    obj.message = 'Error consultando cart invoices'
                }
            })
            .catch((e: any) => {
                obj.result = false
                obj.message = 'Error intentando consultar cart invoices'
            })
    } catch (e) {
        obj.result = false
        obj.message = 'Error intentando consultar cart invoices'
    }
    return obj;
}


//////////////////////////////////
// GET FACTURAS FILIALES :::::::::
export const RequestInvoiceFilial = async (data: requestFactura) => {
    let obj: {
        result: boolean,
        [key: string]: any
    } = { result: false };
    const isOnline = await checOnlineStatus();
    if (!isOnline) {
        return {
            result: false,
            message: config.alertas.conexion
        }
    }
    /*
    const tokenCaptcha = await window.grecaptcha.execute(config.CaptchaKey, {
        action: 'RequestInvoiceMovistar',
    });
    */
    switch (data.comerce) {
        case 'metrotel':
            obj.data = {
                dominio: config.REACT_APP_METROTEL_DOMINIO,
                public_key: config.REACT_APP_METROTEL_RECAUDO_PUBLIC_KEY,
                band: config.REACT_APP_TELEBUCARAMANGA_BAND,
                referencia: data.paymentRef,
                option: data.invoiceType == 'telefono' ? 'telefono' : data.invoiceType,
            };
            break;
        case 'telebucaramanga':
            obj.data = {
                option: data.invoiceType == 'telefono' ? 'telefono' : data.invoiceType,
                dominio: config.REACT_APP_TELEBUCARAMANGA_DOMINIO,
                public_key: config.REACT_APP_TELEBUCARAMANGA_RECAUDO_PUBLIC_KEY,
                band: config.REACT_APP_TELEBUCARAMANGA_BAND,
                referencia: data.paymentRef,
            };
            break;
    }

    try {
        await axios({
            method: 'post',
            url: `${config.REACT_APP_AMBIENTE}/api/recaudo/proyecto/consultar/facturas`,
            data: obj.data,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "X-api-key": ''
            }
        })
            .then(async (resp: any) => {
                if (resp.status === 200) {
                    let data = resp.data.data;
                    let { ultraFacturas, accion, parametrosConsultaSuscripcion, isSuscrito } = data;
                    if (ultraFacturas && ultraFacturas.facturas[0]) {
                        if (ultraFacturas.facturas[0].total) {
                            obj.ultraFacturas = ultraFacturas;
                            obj.accion = accion;
                            obj.parametrosConsultaSuscripcion = parametrosConsultaSuscripcion;
                            obj.isSuscrito = isSuscrito;
                            obj.result = true
                            obj.message = 'Facturas consultadas con éxito.'
                            recoletNewVals({ action: accion, number: obj.data.referencia }, InvoicesCanCuscribe);
                        } else if (ultraFacturas.facturas[0].total == 0) {
                            obj.message = config.alertas.saldo0;
                            obj.saldo0 = true;
                        }

                    }
                    else {
                        obj.message = config.alertas.sinfacturas;
                    }
                }
                else obj.message = 'Error consultando facturas.'

            })
            .catch((e: any) => {
                obj.message = config.alertas.facturas
            })
    } catch (e) {
        obj.message = config.alertas.facturas
    }
    return obj;
}

const parseJwt = (token: string) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
};

//////////////////////////////////
// GET TOKEN :::::::::::::::::::::
export const GetToken = async () => {

    let obj: tkn = {
        result: false,
        token: '',
        message: '',
    };

    if (sessionStorage.getItem('token')) {
        obj.result = true;
        obj.token = sessionStorage.getItem('token') || '';
        const decodedToken = parseJwt(obj.token);
        const dateNow = new Date();
        if (decodedToken.exp > (dateNow.getTime() / 1000)) {
            obj.message = "Token generado con éxito";
            return obj;
        }
    }

    try {
        await axios({
            url: `${config.REACT_APP_AMBIENTE}/api/recaudo/get/token`,
            method: "post",
            data: { dominio: `${config.REACT_APP_MOVISTAR_DOMINIO}` }
        })
            .then((data: any) => {
                if (data.status === 200) {
                    obj.result = true;
                    obj.token = data.data.data.token;
                    sessionStorage.setItem('token', obj.token)
                    obj.message = "Token generado con éxito";
                } else {
                    obj.result = false;
                    obj.token = '';
                    obj.message = "Token no generado.";
                }
            })
            .catch((e: any) => {
                obj.result = false;
                obj.token = '';
                obj.message = "Error generando token.";
            })
    } catch (e) {
        obj.result = false;
        obj.token = '';
        obj.message = "Error intentando generar token.";
    }

    return obj;
}


//////////////////////////////////
// REQUEST INVOICES ::::::::::::::
export const GET_FACTURAS = async (data: requestFactura, tags: boolean = true, showInvoice: boolean = false, turnstileToken?: string) => {
    let obj: {
        [key: string]: any,
        result: boolean
    } = { result: false };
    if (data.paymentRef && tags) {
        setNewTagCI360(formatConsultFormData(data))
    }

    if (data.comerce !== 'telebucaramanga' && data.comerce !== 'metrotel') {
        let token = await GetToken();
        if (token.result) {
            data.token = token.token;
            let Facturas = await RequestInvoiceMovistar(data, turnstileToken);
            if (Facturas.result) {
                if (showInvoice || !Facturas.getLastPay) {
                    obj.result = true;
                    obj = {
                        ...Facturas,
                        ...obj
                    }
                } else {
                    obj.result = true;
                    obj.getLastPay = true;
                }
            } else {
                obj.message = Facturas.message
                obj.result = false;
            }
        } else {
            obj.message = config.alertas.token
            obj.result = false;
        }
    }

    else {
        let response = await RequestInvoiceFilial(data)
        if (response.result) {
            obj = { ...obj, ...response };
        } else {
            obj.message = response.message;
            obj.result = false;
        }
    }
    return obj;
}


//////////////////////////////
// REQUEST CART ::::::::::::::
export const REQUEST_CART = async (data: requestFactura, filial: number, turnstileToken?: string) => {
    let obj: {
        [key: string]: any,
        result: boolean
    } = { result: false, facturas: [] };

    let token = await GetToken();

    let tipoarchivo = data.comerce === "movistar" ? 'online' : 'archivo';

    if (token.result) {
        data.token = token.token;
        let dataCartResult = await RequestCart(data.token, data.paymentRef, tipoarchivo, filial, turnstileToken);
        if (dataCartResult.result) {
            obj.result = true;
            obj.facturas = dataCartResult.facturas;
        } else {
            obj.message = 'Error consultando cart invoices ::'
            obj.ultraFactura = dataCartResult.ultraFactura
            obj.result = false;
        }
    } else {
        obj.message = config.alertas.token
        obj.result = false;
    }

    return obj;
}

export const GET_LAST_PAY = async (identificacionEmpresa: string) => {
    let obj: {
        result: boolean,
        data: any,
        message: string,
    } = { result: false, data: [], message: '' };
    try {
        /*
        const tokenCaptcha = await window.grecaptcha.execute(config.CaptchaKey, {
            action: 'RequestGetLastPay',
        });
        */
        await axios({
            url: `${config.REACT_APP_MOVISTAR_GET_PAY}`,
            method: "post",
            data: {
                dominio: `${config.REACT_APP_MOVISTAR_DOMINIO_RECAUDO}`,
                public_key: `${config.REACT_APP_MOVISTAR_RECAUDO_PUBLIC_KEY}`,
                cliente: `${config.REACT_APP_MOVISTAR_ID_COMERCIO}`,
                paymentRef: identificacionEmpresa
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "X-api-key": ''
            }
        })
            .then((data: any) => {
                if (data.data.success == true) {
                    obj.result = true;
                    obj.data = data.data;
                    obj.message = "Ultimo Pago Consultado con Éxito";
                } else {
                    obj.result = false;
                    obj.data = '';
                    obj.message = "Ultimo Pago Consultado.";
                }
            })
            .catch((e: any) => {
                obj.result = false;
                obj.data = '';
                obj.message = "Error intentando consultar ultimo pago.";
            })
    } catch (e) {
        obj.result = false;
        obj.data = '';
        obj.message = "Error intentando consultar ultimo pago.";
    }
    return obj;
}